<template>
  <div :class="wrapperClass">
    <el-menu
      :collapse="menuCollapse"
      mode="vertical"
      :router="true"
      :default-active="activeRoute"
      unique-opened
    >
      <template v-for="(item, index) in menu">
        <template v-if="item.show !== false">
          <el-submenu :key="index" v-if="item.children" :index="item.name">
            <template slot="title">
              <i
                v-if="item.icon"
                :class="[
                  item.icon,
                  { 'tg-icon': item.icon.startsWith('tg-icon') },
                ]"
              ></i>
              <span :class="{ 'line-height': !item.icon }">
                {{ $t("menu." + item.name + ".title") }}
              </span>
              <em
                v-if="badge[item.name] && badge[item.name] > 0"
                class="badge"
                >{{ badge[item.name] | MoreThenTen }}</em
              >
            </template>
            <template v-for="(sub, x) in item.children">
              <el-menu-item
                v-if="sub.show !== false"
                :index="sub.name"
                :route="{
                  name: sub.name,
                  params:
                    'props' in sub
                      ? { ...sub.props, invoke: 'menu' }
                      : { invoke: 'menu' },
                }"
                :key="x"
                @click.native="handleMenuClick"
              >
                <a :href="sub.path">
                  <i v-if="sub.icon" :class="sub.icon"></i>
                  <span :class="{ 'line-height': !!sub.icon }">
                    {{ $t("menu." + sub.name) }}
                  </span>
                </a>
              </el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item
            v-else
            :index="item.name"
            :route="{
              name: item.name,
              params: 'props' in item ? item.props : {},
            }"
            :key="item.name"
            @click.native="handleMenuClick"
            style="padding: 0 0 0 4px"
          >
            <a :href="item.path">
              <i
                v-if="item.icon"
                :class="[
                  item.icon,
                  { 'tg-icon': item.icon.startsWith('tg-icon') },
                ]"
              ></i>
              <span :class="{ 'line-height': !!item.icon }">
                {{ $t("menu." + item.name) }}
              </span>
              <em
                v-if="badge[item.name] && badge[item.name] > 0"
                class="badge"
                >{{ badge[item.name] | MoreThenTen }}</em
              >
            </a>
            <Audio v-if="item.name === 'assistence'" @mounted="setAudioRef" />
          </el-menu-item>
        </template>
      </template>
    </el-menu>
    <tg-url-list v-if="hasUrl"></tg-url-list>
  </div>
</template>

<script>
import _ from "lodash";
import authorize from "../../utils/authorize";
import TgUrlList from "./TgUrlList";
import Audio from "../audio/audios.vue";

const validateMenu = (menu, user) => {
  let map = [];
  menu.forEach((item) => {
    let tmp = _.cloneDeep(item);
    if (tmp.children) {
      tmp.children = validateMenu(tmp.children, user);
      if (!tmp.children.some((x) => x.show)) {
        tmp.show = false;
      }
    }
    if (!authorize.pass(user, tmp.permissions)) {
      tmp.show = false;
    }
    map.push(tmp);
  });
  return map;
};

export default {
  name: "TgNavigation",
  components: {
    TgUrlList,
    Audio,
  },
  data() {
    return {
      showToggleBtn: true,
      activeName: "0",
      audioRef: null,
    };
  },
  props: {
    classes: [String, Array, Object],
    collapse: Boolean,
    width: String,
  },
  computed: {
    wrapperClass() {
      let defClasses = ["tg-navigation", { collapse: this.menuCollapse }];
      let classes = this.classes;
      if (!classes) {
        return defClasses;
      }

      if (typeof classes === "string" || typeof classes === "object") {
        defClasses.push(classes);
      }

      if (Array.isArray(classes)) {
        defClasses.concat(classes);
      }

      return classes;
    },
    menu() {
      let menu = validateMenu(this.$store.state.app.menu, this.$user);
      return menu;
    },
    badge() {
      return this.$store.state.app.badge;
    },
    activeRoute() {
      if (_.endsWith(this.$route.name, "index")) {
        return this.$route.name.replace(".index", "");
      }
      return this.$route.name;
    },
    menuCollapse() {
      return this.$store.state.app.menuCollapse;
    },
    hasUrl() {
      return this.$store.state.app.url.mobile.length > 0;
    },
    isNotice() {
      return this.$store.state.app.isNotice;
    },
  },
  methods: {
    handleMenuClick() {
      this.$store.commit("app/TOGGLE_MENU_DRAWER", false);
      this.initAudio();
    },
    setAudioRef(el) {
      this.audioRef = el;
    },
    initAudio() {
      if (this.audioRef) {
        this.audioRef.muted = true;
        this.audioRef.play().then(() => {
          this.audioRef.pause();
          this.audioRef.currentTime = 0;
          this.audioRef.muted = false;
          if (Number(this.badge.assistence) > 0 && !this.isNotice) {
            this.$store.commit("app/SHOW_BEEP", true);
          }
        });
      }
    },
  },
  mounted() {
    this.initAudio();
  },
};
</script>
